// The dimmed backdrop behind the open mobile nav is a :before pseudo-element (see
// .site-header--row in _header.scss) — pseudo-elements can't have their own click listeners,
// so closing the nav on an "outside click" has to be handled here instead. Any click while the
// nav is open that lands outside both the nav panel and its toggle button simulates a real
// click on the toggle button. Bootstrap's Collapse component registers its own document-level
// delegated click listener for any [data-bs-toggle="collapse"] element, so this reuses that
// exact same close path (and event sequence header/index.js's navToggleClass() already listens
// for) instead of instantiating a second, possibly out-of-sync Collapse instance.
export default function () {

  const nav = document.getElementById('siteNav');
  const toggle = document.getElementById('navToggle');
  if (!nav || !toggle) return;

  document.addEventListener('click', function (event) {
    if (!document.body.classList.contains('nav-open')) return;
    if (nav.contains(event.target) || toggle.contains(event.target)) return;

    toggle.click();
  });

}
